
export enum Language {
  nb = 'nb',
  nn = 'nn',
  en = 'en',
}

export const languageToLocaleMap = {
  [Language.nb]: 'nb-NO',
  [Language.nn]: 'nn-NO',
  [Language.en]: 'en-GB',
};
